require('../modules/es6.date.now');
require('../modules/es6.date.to-json');
require('../modules/es6.date.to-iso-string');
require('../modules/es6.date.to-string');
require('../modules/es6.date.to-primitive');
module.exports = Date;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/es6/date.js
// module id = 667
// module chunks = 5